import React from 'react';
import {
  Stack, ListItem, SxProps, Tooltip,
} from '@mui/material';
import {
  ListItemCardSubtitle,
  ListItemCardTitle,
  LinkCard,
  ZAvatar,
} from '@marageti/z4-lib';
import { RoleName } from '@marageti/z4-sdk/lib/auth';
import {
  Agent, TeamMember, Traveler,
} from '@marageti/z4-sdk/lib/people';
import { peopleStatusIcons } from '../status-icons';
import { getMatchingUser } from '../../utils/auth';

const roleDisplayNames: Partial<Record<RoleName, string>> = {
  [RoleName.ADMIN]: 'Admin',
  [RoleName.CARE]: 'Care',
  [RoleName.DATA]: 'Data',
  [RoleName.MARKETING]: 'Marketing',
  [RoleName.PARTNERSHIPS]: 'Partnerships',
  [RoleName.PHOTO]: 'Photo',
  [RoleName.AGENT]: 'Specialist',
  [RoleName.AGENT_ADMIN]: 'Manager',
  [RoleName.AGENT_SUPPORT]: 'Support',
};

const getRoleDisplayName = (roles: RoleName[] | null): string => {
  if (!roles || roles.length === 0) return '';
  return roles.map((role) => roleDisplayNames[role]).join(', ');
};

type Props<T> = {
  loading?: boolean;
  individual: T;
  zRole?: string | undefined;
  to: string;
  sx?: SxProps;
};

const ListItemLinkPersondWithRole = <T extends TeamMember | Traveler | Agent>({
  individual,
  loading = false,
  zRole = undefined,
  to,
  sx = {},
}: Props<T>) => {
  const userInfo = getMatchingUser(individual.email, individual.userInfo);
  return (
    <ListItem disablePadding sx={sx}>
      <LinkCard
        key={individual.id}
        to={to}
        state={individual}
        sx={{
          width: '100%',
          minWidth: {
            desktop: '662px',
          },
        }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            gap={2}
          >
            <ZAvatar
              name={individual.fullName}
              size={40}
              loading={loading}
              src={individual.avatar}
            />
            <Stack alignItems="space-between" minHeight="45px" sx={{ marginLeft: '16px' }}>
              <ListItemCardTitle>
                {`${individual.givenName} ${individual.familyName}`}
              </ListItemCardTitle>
              <ListItemCardSubtitle>
                {zRole || getRoleDisplayName(userInfo!.roles)}
              </ListItemCardSubtitle>
            </Stack>
          </Stack>
          {userInfo && (
            <Tooltip title={peopleStatusIcons[userInfo.status].displayName} placement="right">
              <span>
                {peopleStatusIcons[userInfo.status].icon}
              </span>
            </Tooltip>
          )}
        </Stack>
      </LinkCard>
    </ListItem>
  );
};

export default ListItemLinkPersondWithRole;
